import React, { useState } from "react";
import { T } from "./theme";
import { SectionHeader } from "./ui";
import Clientes from "./Clientes";
import Logistica from "./Logistica";
import Simulador from "./Simulador";
import AssistenteIA from "./AssistenteIA";

const TABS = [
  { id: "crm", label: "📋 CRM" },
  { id: "logistica", label: "🚚 Logística" },
  { id: "suporte", label: "💬 Suporte" },
  { id: "simulador", label: "🏠 Simulador" },
  { id: "ia", label: "🤖 Assistente IA" },
];

export default function ClientesHub(props) {
  const [tab, setTab] = useState("crm");

  function renderTab() {
    switch (tab) {
      case "crm": return <Clientes clientes={props.clientes} setClientes={props.setClientes} corretores={props.corretores} />;
      case "logistica": return <Logistica pedidos={props.pedidos} setPedidos={props.setPedidos} corretores={props.corretores} />;
      case "suporte":
        return (
          <div style={{ padding: 40, textAlign: "center", color: T.textDim }}>
            🎫 Módulo de Suporte com tickets será construído na próxima sessão.
          </div>
        );
      case "simulador": return <Simulador />;
      case "ia": return <AssistenteIA />;
      default: return null;
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <SectionHeader icon="📋" title="Clientes" subtitle="CRM pós-venda, logística, suporte e ferramentas" />
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding: "8px 14px", borderRadius: T.r.md,
            background: tab === t.id ? T.brand + "22" : T.card,
            border: `1px solid ${tab === t.id ? T.brand : T.border}`,
            color: tab === t.id ? T.brand : T.textSec,
            cursor: "pointer", fontSize: 11, fontWeight: 600, fontFamily: "inherit",
          }}>
            {t.label}
          </button>
        ))}
      </div>
      {renderTab()}
    </div>
  );
}
